import { Action } from '@ngrx/store';

export function getClearSelectionType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Clear Selection ${(type as any).$typeName}`;
}

export class ClearSelectionAction<TModel> implements Action {
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }) {
    this.type = getClearSelectionType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/ClearSelectionAction.ts